<template lang="pug">
#modal-visualizacao-laudo
    el-dialog(
        :title="$t('mensagens.laudos.inserirResultadosDoLaudoConformidadeAmbientalCar')",
        width='500px',
        top='5vh',
        :visible='show',
        @close='closeDialog'
    )
        p.mb-1 {{ $t('mensagens.laudos.solicitante') }}: {{ rowInfo.usuarioSolicitacaoNome }}
        p.mb-1 {{ $t('mensagens.laudos.territorio') }}: {{ rowInfo.informacaoLaudo.nomeTerritorio }}
        p.mb-1 {{ $t('mensagens.laudos.car') }}: {{ rowInfo.informacaoLaudo.car.codigo }}

        hr

        h4.font-weight-bold.py-3 {{ $t('mensagens.laudos.uploadDeInsumos.declarados') }}
            el-tooltip(:content="`${$t('mensagens.laudos.arquivosPermitidosEmFormato')}: zip.`")
                i.mdi.mdi-information(
                    style='vertical-align: middle; margin-left: 5px'
                )
        el-upload.upload-demo(
            action='#',
            drag,
            :file-list='fileListInsumosDeclarados',
            :auto-upload='false',
            :on-change='onLoadFileInsumosDeclarados',
            :on-remove='onRemoveFileInsumosDeclarados',
            ref='upload'
        )
            i.el-icon-upload
            .el-upload__text.w-100 {{ $t('mensagens.laudos.arrasteArquivoAqui.1') }}<em>{{ $t('mensagens.laudos.arrasteArquivoAqui.2') }}</em>

        h4.font-weight-bold.py-3 {{ $t('mensagens.laudos.uploadDeInsumos.classificados') }}
            el-tooltip(
                :content="`${$t('mensagens.laudos.arquivosPermitidos')}: vegetacao_nativa.zip, vegetacao_nativa_app.zip, uso_consolidado.zip, area_antropizada.zip, reserva_legal.zip, hidrografia.zip, app_total.zip, app_recompor.zip, app_degradada.zip.`"
            )
                i.mdi.mdi-information(
                    style='vertical-align: middle; margin-left: 5px'
                )
        el-upload.upload-demo(
            action='#',
            drag,
            :file-list='fileListInsumosClassificados',
            :auto-upload='false',
            :on-change='onLoadFileInsumosClassificados',
            :on-remove='onRemoveFileInsumosClassificados',
            ref='upload'
        )
            i.el-icon-upload
            .el-upload__text.w-100 {{ $t('mensagens.laudos.arrasteArquivoAqui.1') }}<em>{{ $t('mensagens.laudos.arrasteArquivoAqui.2') }}</em>

        .d-flex.flex-direction.justify-content-between.py-3
            BaseButton(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
            BaseButton(
                slot='footer',
                size='mini',
                type='primary',
                @click='inserirResultado'
            ) {{ $t('mensagens.comuns.finalizar') }}
</template>

<script>
import LaudoService from '@/services/LaudosService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalInsercaoResultados',

    components: {
        BaseButton
    },

    emits: ['update:show', 'update:lista'],

    props: {
        show: {
            type: Boolean,
            required: true
        },
        rowInfo: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            radio: null,
            listaArquivoInsumosDeclarados: [],
            listaArquivoInsumosClassificados: [],
            fileListInsumosDeclarados: [],
            fileListInsumosClassificados: [],
            msgError: ''
        };
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('update:show', false);
        },

        inserirResultado() {
            if (!this.listaArquivoInsumosDeclarados.length) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.arquivoDeInsumosDeclaradosObrigatorio')
                });
                return;
            }

            if (!this.listaArquivoInsumosClassificados.length) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.arquivoDeInsumosClassificadosObrigatorio')
                });
                return;
            }

            let list = [
                ...this.listaArquivoInsumosDeclarados,
                ...this.listaArquivoInsumosClassificados
            ];

            const promises = Promise.all(
                list.map(async value => {
                    await this.salvarResultado(
                        this.rowInfo.id,
                        value.tipoInsumo,
                        value.raw,
                        value.name
                    );
                })
            );

            this.msgError = '';

            promises
                .then(() => {
                    if (this.msgError !== '') {
                        this.$notify.error({
                            message: this.msgError,
                            dangerouslyUseHTMLString: true
                        });
                        return false;
                    }

                    this.$notify.success({
                        message: this.$t('mensagens.laudos.resultadosAdicionadosComSucesso')
                    });
                    this.closeDialog();
                    this.$emit('update:lista', false);

                    this.msgError = '';
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.laudos.erro.ocorreuUmErroAoAdicionarResultadoInsumosDeclarados')
                    });
                    this.msgError = '';
                });
        },

        async salvarResultado(id, tipoInsumo, arquivo, nome) {
            await LaudoService.uploadResultadoConformidade(
                id,
                tipoInsumo,
                arquivo
            )
                .then(response => {
                    if (response.status !== 200) {
                        this.msgError +=
                            `<br> ${this.$t('mensagens.laudos.erro.naoFoiPossivelEnviarArquivoSemFinal')} ` +
                            nome +
                            '. ' +
                            response +
                            ' </br>';
                    }
                })
                .catch(error => {
                    this.msgError +=
                        `<br> ${this.$t('mensagens.laudos.erro.naoFoiPossivelEnviarArquivoSemFinal')} ` +
                        nome +
                        '. ' +
                        error.response.data +
                        ' </br>';
                });
        },

        onLoadFileInsumosDeclarados(file, fileList) {
            const isZip = file.raw.type === 'application/x-zip-compressed';
            if (!isZip) {
                fileList.pop();
                this.$notify.warning({
                    message: this.$t('mensagens.laudos.erro.tipoDeArquivoNaoPermitido')
                });
            } else {
                file.tipoInsumo = 'DECLARADOS';
                this.listaArquivoInsumosDeclarados.push(file);
            }
        },

        onLoadFileInsumosClassificados(file, fileList) {
            const nomesPermitidos = [
                'vegetacao_nativa.zip',
                'vegetacao_nativa_app.zip',
                'area_antropizada.zip',
                'uso_consolidado.zip',
                'reserva_legal.zip',
                'hidrografia.zip',
                'app_total.zip',
                'app_recompor.zip',
                'app_degradada.zip'
            ];

            if (nomesPermitidos.includes(file.name)) {
                file.tipoInsumo = 'CLASSIFICADOS';
                this.listaArquivoInsumosClassificados.push(file);
            } else {
                fileList.pop();
                this.$notify.warning({
                    message: this.$t('mensagens.laudos.erro.nomeOuTipoArquivoForaDoPadrao')
                });
            }
        },

        onRemoveFileInsumosDeclarados(file) {
            _.remove(this.listaArquivoInsumosDeclarados, o => {
                return o.uid === file.uid;
            });
        },

        onRemoveFileInsumosClassificados(file) {
            _.remove(this.listaArquivoInsumosClassificados, o => {
                return o.uid === file.uid;
            });
        },

        clearFields() {
            this.radio = null;
            this.fileListInsumosDeclarados = [];
            this.fileListInsumosClassificados = [];
            this.listaArquivoInsumosDeclarados = [];
            this.listaArquivoInsumosClassificados = [];
        }
    }
};
</script>

<style lang="scss">
#modal-visualizacao-laudo {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .el-upload,
    .el-upload--text,
    .el-upload-dragger {
        width: 100%;
    }
}
</style>
